/**
 * Nsection B8 Service
 * B.8.活動邊界 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b8';

export interface GhgItem {
  gas_id: number;
  is_included: boolean;
  relationship: string;
  justification: string;
}

export interface EmissionSource {
  source: string;
  ghg: GhgItem[];
}

export interface NsectionB8Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  boundary_description: string | null;
  baseline_emissions: EmissionSource[] | null;
  activity_emissions: EmissionSource[] | null;
  leakage_emissions: EmissionSource[] | null;
  nsection_b8_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB8Update {
  boundary_description?: string;
  baseline_emissions?: EmissionSource[];
  activity_emissions?: EmissionSource[];
  leakage_emissions?: EmissionSource[];
}

const nsectionB8Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB8Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB8Update): Promise<NsectionB8Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB8Service;
